export const ApiEntityKeys = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const all = async (id, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/keys`)
    return result.data
  }

  const save = async (id, module = 'accommodations', payload) => {
    const result = await axios.post(`/api/entities/${module}/${id}/keys/${payload.key.id}`, payload)
    return result.data
  }

  const remove = async (id, cid, module = 'accommodations') => {
    const result = await axios.delete(`/api/entities/${module}/${id}/keys/${cid}`)
    return result.data
  }

  return {
    entityKeysAll: all,
    entityKeysSave: save,
    entityKeysRemove: remove
  }
}
